import React from 'react'
import { connect } from 'react-redux'
import Textbox from '../components/Textbox'

const HomePlans = ({ plans, uid }) => (
  plans.planData ?
    <div className="plan">
      <Textbox 
        title = {plans.currentPlanId + ' 個人目標'}
        text = {plans.planData[plans.currentPlanId][uid]? plans.planData[plans.currentPlanId][uid].plan : ' '}
        editable = {true}
        editLink = '/plan/edit/'
      />
    </div>
  :
    <div>Loading...</div>
)

export default connect(
  state => ({
    plans: state.plans,
    uid: state.user.uid
  })
)(HomePlans)



// WEBPACK FOOTER //
// ./src/components/HomePlans.js